module.exports = __webpack_public_path__ + "img/erweima1.3fe35a5a.png";